import { Typography, TypographyProps } from '@material-ui/core';

import { Theme } from '@material-ui/core';

import { makeStyles } from '@material-ui/core';
import { getTypographyColor, typographyColorKeys } from 'src/data/colors';

const FONT_FAMILY = {
  sans: 'DM Sans',
  mono: 'DM Mono',
} as const;

const FONT_SIZE = {
  12: '12px',
  14: '14px',
  16: '16px',
  22: '22px',
} as const;

type FontFamily = keyof typeof FONT_FAMILY;
type FontSize = keyof typeof FONT_SIZE;

interface StylesProps {
  color: string;
  fontFamily: FontFamily;
  fontSize: FontSize;
  lineHeight: string;
  fontWeight: number;
}

const useStylesText = makeStyles<Theme, StylesProps>((theme: Theme) => ({
  root: {
    fontSize: ({ fontSize }) => FONT_SIZE[fontSize],
    fontWeight: ({ fontWeight }) => fontWeight,
    lineHeight: ({ lineHeight }) => lineHeight,
    fontFamily: ({ fontFamily }) => FONT_FAMILY[fontFamily],
    color: ({ color }) => color,
  },
}));

type TextProps = Omit<TypographyProps, 'color'> & {
  color?: keyof typeof typographyColorKeys;
  fontFamily?: FontFamily;
  fontSize?: FontSize;
  lineHeight?: string;
  fontWeight?: number;
};

export const Text = ({
  children,
  color,
  fontFamily = 'sans',
  fontSize = 16,
  lineHeight = '24px',
  fontWeight = 400,
  ...props
}: TextProps) => {
  const selectedColor = getTypographyColor(color || 'primaryText');
  const classes = useStylesText({
    color: selectedColor,
    fontFamily,
    fontSize,
    lineHeight,
    fontWeight,
  });

  return (
    <Typography {...props} className={`${classes.root} ${props.className}`}>
      {children}
    </Typography>
  );
};
